import * as types from '../actions/types'
import Immutable from 'immutable'
import moment from 'moment'


import {
    isPrimitive,
    alojamiento,
    huesped,
    solicitudcenco,
    foro
} from '../utils/helpers'



const INITIAL_STATE = Immutable.fromJS({
    fecha_solicitud: moment().format('YYYY-MM-DD'),
    motivo_hospedaje: null,
    cant_huespedes: 1,
    observaciones: '',
    alojamientos: [alojamiento()],
    huespedes: [huesped()],
    adjuntos: [],
    btnSaveDisabled: false,
    cencos: [],
    tipo: 8,
    foros:[],
    comentario: {
        guid: null,
        texto: null
    }
})


export default function (state = INITIAL_STATE, action) {

    let index, huespedes,adjuntos;

    switch (action.type) {

        case types.REINICIAR_SOLICITUD_HOTELES:
            return INITIAL_STATE

        case types.MODIFICAR_INPUTS_SOLICITUD_HOTELES:

            if (isPrimitive(action.payload.value)) {
    			state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
            } else {
                if (action.payload.immutable === false) {
                    state = state.setIn(`${action.payload.path}`.split('.'), action.payload.value)
                } else {
                    state = state.setIn(`${action.payload.path}`.split('.'), Immutable.fromJS(action.payload.value))
                }
            }


            if (state.get('cant_huespedes') > state.get('huespedes').count()) {
                for(let i=state.get('huespedes').count(); i < state.get('cant_huespedes'); i++) {
                    state = state.setIn(['huespedes',i], Immutable.fromJS(huesped()))
                }
            }

            if (state.get('cant_huespedes') < state.get('huespedes').count()) {
                huespedes = state.get('huespedes').toJS().splice(0,state.get('cant_huespedes'))
                state = state.set('huespedes', Immutable.fromJS(huespedes))
            }

            return state


        case types.ADICIONAR_ALOJAMIENTO:
            index = state.get('alojamientos').count()
            state = state.setIn(['alojamientos',index], Immutable.fromJS(alojamiento()))
            return state



        case types.REMOVER_ALOJAMIENTOS:
            state = state.update('alojamientos', list => list.filter(x => !x.get('selected')))
            return state



        case types.DESHABILITAR_BOTON_GUARDAR_SOLICITUD_HOTELES:
            state = state.set('btnSaveDisabled', action.payload)
            return state

        case types.ADICIONAR_ELEMENTO_LISTA_SOLICITUD_HOTELES:
            state = state.setIn(action.payload.path.split('.'),  Immutable.fromJS(action.payload.value))
            return state


        case types.ADICIONAR_NUEVO_CENCO_SOLICITUD_HOTELES:
            let actual = state.get('cencos').reduce((a ,b) => { a += Number(b.get('porcentaje')); return a }, 0)
			state = state.update('cencos', list => list.push(Immutable.fromJS(solicitudcenco(actual))))
            return state


        case types.REMOVER_CENCOS_HOTELES:
            state = state.update('cencos', list => list.filter(x => !x.get('selected')))
            return state



        case types.ENVIAR_COMENTARIO_SOLICITUD_HOTELES:
            index = state.get('foros').findIndex(c => c.get('guid') === action.payload.guid)
            if(index === -1){
                const data = Immutable.fromJS(foro(action.payload.usuario, action.payload.comentario))
                state = state.set('foros', state.get('foros').push(data))
            }else{
                state = state.setIn(['foros', index, 'comentario'], action.payload.comentario)
            }
            state = state.set('comentario', INITIAL_STATE.get('comentario'));
            return state

        case types.EDITAR_COMENTARIO_SOLICITUD_HOTELES:
            index = state.get('foros').findIndex(c => c.get('guid') === action.payload.guid)
            state = state.setIn(['comentario','guid'], action.payload.guid)
            state = state.setIn(['comentario','texto'], state.getIn(['foros', index, 'comentario']))
            return state

        case types.ELIMINAR_COMENTARIO_SOLICITUD_HOTELES:
            index = state.get('foros').findIndex(c => c.get('guid') === action.payload.guid)
            state = state.deleteIn(['foros', index])
            return state

        case types.ADICIONAR_NUEVO_ARCHIVO_SOLICITUD_HOTELES1:
            index = action.payload
            adjuntos = state.get('adjuntos').findIndex(x => x.get('guid') === index.get('guid'))
            index = index.set('nombre', `${index.get('nombre')}`)
            if (adjuntos === -1) {
                state = state.set('adjuntos', state.get('adjuntos').push(index))
            } else {
                index = index.set('updated', true)
                state = state.setIn(['adjuntos', String(adjuntos)], index)
            }
            return state
        case types.ELIMINAR_ARCHIVOS_SOLICITUD_HOTELES:
            state = state.update('adjuntos', list => list.filter(x => !x.get('selected')))
            return state
       	default:
            return state
    }

}



// WEBPACK FOOTER //
// ./src/reducers/creacionsolicitudhoteles.js